export default __webpack_public_path__ + "static/media/13.209e5df1.png";